export const L10N = {
  LABEL_SELECT_CURRENCY: { id: 'common.label.select_currency' },
  LABEL_SELECT_LANGUAGE: { id: 'common.label.select_language' },
};
